module.exports = __webpack_public_path__ + "static/media/Thankyou page.e818fd8a.pdf";